import { render } from "./Expansions.vue?vue&type=template&id=4e7c1c30"
import script from "./Expansions.vue?vue&type=script&lang=js"
export * from "./Expansions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/residence/Expansions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e7c1c30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e7c1c30', __exports__)) {
    api.reload('4e7c1c30', __exports__)
  }
  
  module.hot.accept("./Expansions.vue?vue&type=template&id=4e7c1c30", () => {
    api.rerender('4e7c1c30', render)
  })

}


export default __exports__